export default (() => {
  function capitalizeFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  function capitalizeFirstLetterEveryWord(string = '') {
    return string.replace(
      /[a-zа-я]+/gi,
      (match) => match[0].toUpperCase() + match.substr(1),
    );
  }

  return {
    capitalizeFirstLetter,
    capitalizeFirstLetterEveryWord,
  };
})();
